import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AdminService} from '../../../services/admin.service';
import {MultiQuestions} from '../../../models/multi-questions';
import {TranslateQuestionModel} from '../../../models/translate-question.model';

@Component({
  selector: 'app-translate-questions',
  templateUrl: './translate-questions.component.html',
  styleUrls: ['./translate-questions.component.css']
})
export class TranslateQuestionsComponent implements OnInit {

  private urlID = '';                               // Get standard ID from URL
  private allQuestions: any;                        // Save here all questions from standard
  private allQuestionsToCopy: any;                  // Save here all questions from standard to copy
  public loadingError = false;                     // Show error message if we have http request error
  public isLoadedTests = false;                    // Show loading spinner while component is loading
  public errorMsg = '';                            // Error text message if we have loading error
  public standardBaseLanguage = '';                // Save here base standard language
  // private allTranslatedQuestions: any[] = [];    // Save here translates questions for sending to server

  public translateError = false;
  public disableTranslateBtn = false;
  public toolTipAllCopyMsg = '';
  public toolTipOneCopyMsg = '';
  private invalidDataMsg = false;

  public showSuccessMsg = false;
  public showErrorMsg = false;

  public megaList = {
    rus: [],
    eng: []
  };

  private allQuestionsTr = {
    russian: [],
    english: []
  };

  // private questionModel = {
  //   questionText: '',
  //   rightAnswer: {
  //     answerText: ''
  //   },
  //   answers: [
  //     {
  //       answerText: ''
  //     },
  //     {
  //       answerText: ''
  //     },
  //     {
  //       answerText: ''
  //     }
  //   ]
  // };

  constructor(private route: ActivatedRoute,
              private router: Router,
              private adminService: AdminService) {
  }

  ngOnInit() {
    // Get standard ID from URL
    this.urlID = this.route.snapshot.params['id'];

    this.toolTipAllCopyMsg = 'Copy All Question and Answers to Clipboard';
    this.toolTipOneCopyMsg = 'Copy this Question and Answers to Clipboard';
    this.isLoadedTests = false;
    this.loadingError = false;
    this.translateError = false;
    this.disableTranslateBtn = false;
    this.invalidDataMsg = false;

    this.errorMsg = '';
    this.standardBaseLanguage = '';

    this.showSuccessMsg = false;
    this.showErrorMsg = false;

    // Get questions by standard ID, URL: common/{sid}/translate/questions
    this.adminService.getQuestionForTranslateByStandardID(this.urlID).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.allQuestions = res.body;
          this.loadingError = false;

          // Get standard base language by standard ID
          this.getStandardBaseLanguageByID(this.urlID);

        } else if (res.status === 204) {
          this.errorMsg = 'The standard does not have questions for translation.';
          this.loadingError = true;
          this.isLoadedTests = true;
        } else {
          this.errorMsg = 'Error getting a list of questions.';
          this.loadingError = true;
          this.isLoadedTests = true;
        }
      },
      () => {
        this.errorMsg = 'Error getting a list of questions.';
        this.loadingError = true;
        this.isLoadedTests = true;
      }
    );
  }

  // Initialize array for translated questions
  initTranslatedQuestionsArray() {
    // Add questions in empty list
    if (this.standardBaseLanguage.toLowerCase() === 'russian' && this.allQuestions.english.length === 0) {
      this.allQuestions.russian.forEach(n => {
        this.allQuestions.english.push(new TranslateQuestionModel());
      });
    } else if (this.standardBaseLanguage.toLowerCase() === 'english' && this.allQuestions.russian.length === 0) {
      this.allQuestions.english.forEach(n => {
        this.allQuestions.russian.push(new TranslateQuestionModel());
      });
    }

    // Create megaList
    this.megaList.rus = this.allQuestions.russian;
    this.megaList.eng = this.allQuestions.english;

  }

  // Use for validation
  isQuestionsvalid() {
    let valid = true;

    if (this.standardBaseLanguage === 'russian') {
      this.megaList.eng.forEach(n => {
        const validationObj = [];
        validationObj.push(n.questionText);
        validationObj.push(n.answers[0].answerText);
        validationObj.push(n.answers[1].answerText);
        validationObj.push(n.answers[2].answerText);

        validationObj.forEach(t => {
          if (t.trim().length < 1) {
            valid = false;
          }
        });
      });

    } else if (this.standardBaseLanguage === 'english') {
      this.megaList.rus.forEach(n => {
        const validationObj = [];
        validationObj.push(n.questionText);
        validationObj.push(n.answers[0].answerText);
        validationObj.push(n.answers[1].answerText);
        validationObj.push(n.answers[2].answerText);

        validationObj.forEach(t => {
          if (t.trim().length < 1) {
            valid = false;
          }
        });
      });
    }

    return valid;
  }


  // Get standard base language by standard ID
  getStandardBaseLanguageByID(sID: string) {
    this.standardBaseLanguage = '';

    this.adminService.getStandardBaseLanguageByID(sID).subscribe(
      (res: any) => {

        if (res.status === 200) {
          this.standardBaseLanguage = res.body;

          // Initialize array for translated questions
          this.initTranslatedQuestionsArray();

          this.loadingError = false;
          this.isLoadedTests = true;
        } else {
          this.errorMsg = 'Error getting a language of standard.';
          this.loadingError = true;
          this.isLoadedTests = true;
        }

      },
      () => {
        this.errorMsg = 'Error getting a language of standard.';
        this.loadingError = true;
        this.isLoadedTests = true;
      }
    );
  }

  // Copy one selected Question and Answers
  copyOneQuestion(quest) {
    // Get question and answers text from question
    const textToCopy = quest.questionText + '\n1. ' + quest.answers[0].answerText +
      '\n2. ' + quest.answers[1].answerText + '\n3. ' + quest.answers[2].answerText + '\n';

    const event = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', textToCopy);
      e.preventDefault();
      document.removeEventListener('copy', event);
    };
    document.addEventListener('copy', event);
    document.execCommand('copy');
  }

  mouseCopyOneUp(p) {
    p.open();
  }

  mouseCopyOneDown(p) {
    p.close();
    this.toolTipOneCopyMsg = 'Copied';
  }

  // Copy ALL Questions to clipboard
  copyAllQuestion() {
    let textToCopy = '';

    switch (this.standardBaseLanguage) {
      case 'russian':
        this.allQuestionsToCopy = this.allQuestions.russian;
        break;
      case 'english':
        this.allQuestionsToCopy = this.allQuestions.english;
        break;
    }

    // Get questions and answers text from each Question in this.allQuestions list
    this.allQuestionsToCopy.forEach(a => {
      textToCopy += a.questionText + '\n1. ' + a.answers[0].answerText +
        '\n2. ' + a.answers[1].answerText + '\n3. ' + a.answers[2].answerText + '\n\n';
    });

    const event = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', textToCopy);
      e.preventDefault();
      document.removeEventListener('copy', event);
    };
    document.addEventListener('copy', event);
    document.execCommand('copy');
  }

  mouseCopyAllUp(t) {
    t.open();
  }

  mouseCopyAllDown(t) {
    t.close();
    this.toolTipAllCopyMsg = 'Copied';
  }

  translateStandard() {
    this.showSuccessMsg = false;
    this.showErrorMsg = false;

    this.invalidDataMsg = false;
    if (this.isQuestionsvalid()) {
      this.disableTranslateBtn = true;
      this.translateError = false;
      this.allQuestionsTr.russian = this.megaList.rus;
      this.allQuestionsTr.english = this.megaList.eng;

      const rusQ = this.allQuestionsTr.russian;
      const engQ = this.allQuestionsTr.english;

      // Выяснить и установить правильные ответы
      if (this.standardBaseLanguage.toLowerCase() === 'russian') {
        // Узнать индексы
        rusQ.forEach(a => {
          a.answers.forEach(answ => {
            if (answ.answerText === a.rightAnswer.answerText) {
              a.rightIndex = a.answers.indexOf(answ);
            }
          });
        });
        // Установить по индексам правильные ответы на английском
        for (let num = 0; num < this.allQuestionsTr.english.length; num++) {
          this.allQuestionsTr.english[num].rightAnswer.answerText = this.allQuestionsTr.english[num]
            .answers[rusQ[num].rightIndex].answerText;
        }

      } else if (this.standardBaseLanguage.toLowerCase() === 'english') {
        // Узнать индексы
        engQ.forEach(a => {
          a.answers.forEach(answ => {
            if (answ.answerText === a.rightAnswer.answerText) {
              a.rightIndex = a.answers.indexOf(answ);
            }
          });
        });

        // Установить по индексам правильные ответы на английском
        for (let num = 0; num < this.allQuestionsTr.russian.length; num++) {
          this.allQuestionsTr.russian[num].rightAnswer.answerText = this.allQuestionsTr.russian[num]
            .answers[engQ[num].rightIndex].answerText;
        }
      }

      // TODO сделать запрос на перевод main_info из встроенного компонента

      this.adminService.doneTranslateQuestions(this.urlID, this.allQuestionsTr).subscribe(
        (res: any) => {
          if (res.status === 200) {
            this.translateError = false;

            this.showSuccessMsg = true;
            this.showErrorMsg = false;
          } else {
            this.showSuccessMsg = false;
            this.showErrorMsg = true;
          }

          this.disableTranslateBtn = false;
        },
        () => {
          this.showSuccessMsg = false;
          this.showErrorMsg = true;

          this.disableTranslateBtn = false;
          this.errorMsg = 'Translation error while sending data to the server.';
          this.translateError = true;
        }
      );

    } else {
      // Show validation data error message
      this.invalidDataMsg = true;
    }
  }


  // b = true if mouse leave copy all questions
  // b = false if mouse leave copy one question
  mouseEnterCopy(b: boolean) {
    let arrSize = 0;
    switch (this.standardBaseLanguage) {
      case 'russian':
        arrSize = this.allQuestions.russian.length;
        break;
      case 'english':
        arrSize = this.allQuestions.english.length;
        break;
    }

    if (b) {
      this.toolTipAllCopyMsg = 'Copy All (' + arrSize + ') Question and Answers to Clipboard';
    } else {
      this.toolTipOneCopyMsg = 'Copy this Question and Answers to Clipboard';
    }
  }

  // Go to home page
  onCancelAction() {
    this.router.navigate(['/dashboard/home']);
  }


}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/translate/translate-questions/translate-questions.component.ts